export const RICONSUMERAPP = {
    submitApproval: 'api/order/v2/1.0/internal/order/submit-approval',
    Jwt: {
        // provisioning
        previewOrder: 'api/reference-implementation/web-application/2.0/internal/order/riconsumerapp/preview',
        submitOrder: 'api/reference-implementation/web-application/2.0/internal/order/riconsumerapp/submit',
        reSubmit: 'api/reference-implementation/web-application/2.0/internal/order/riconsumerapp/resubmit',
        costCalculation: 'api/costs/1.0/ri/cost-calculation',
        internalPreviewOrder: 'api/reference-implementation/web-application/1.0/internal/preview/order',
        downloadTF: 'api/reference-implementation/web-application/1.0/internal/order',
        internalServiceAccount: 'api/day2/1.0/internal/validate-service-account',
        serviceAccountYesValidation: 'api/ri/resource/name/1.0/service-account/validate',
        serviceAccountNoValidation: 'api/day2/1.0/internal/validate-service-account',
        webAppServiceDetails: 'api/static/lookups/v2/1.0/webapp-app-service-details',
        containerTypeDetails: 'api/static/lookups/v2/1.0/container-app-types',
    },
};
export default RICONSUMERAPP;
